import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class Provider extends BaseApi {
	schemaUrl(tableName: string) {
		return `/${this.area}/${this.controller}/${tableName}Schema`;
	}

	tableUrl(tableName: string) {
		return `/${this.area}/${this.controller}/${tableName}Rows`;
	}
}
export const apiProvider = new Provider(DMS_MODULE, NAME);
